import { createProviderToken } from '@core/common-legacy';

export interface TellentAssistantConfig {
  readonly apiUrl: string;
  readonly devPlayground: boolean;
}

export const { provide: provideTellentAssistantConfig, inject: injectTellentAssistantConfig } =
  createProviderToken<TellentAssistantConfig>('TELLENT_ASSISTANT_CONFIG')(false);

export const {
  provide: provideTellentAssistantAuthTokenGetter,
  inject: injectTellentAssistantAuthTokenGetter,
} = createProviderToken<() => string | null>('TELLENT_ASSISTANT_AUTH_TOKEN_GETTER')(false);

export const {
  provide: provideTellentAssistantResourceIdGetter,
  inject: injectTellentAssistantResourceIdGetter,
} = createProviderToken<() => string | null>('TELLENT_ASSISTANT_RESOURCE_ID_GETTER')(false);

export const {
  provide: provideTellentAssistantActorGetter,
  inject: injectTellentAssistantActorGetter,
} = createProviderToken<() => string | null>('TELLENT_ASSISTANT_ACTOR_GETTER')(false);
